export default "__VITE_ASSET__oynEqJfJ__"